import { combineReducers } from 'redux'

import modalReducer from './modalReducer';
import moveMenuReducer from './moveMenuReducer';
import pipetteReducer from './pipetteReducer';
import tipBoxReducer from './tipBoxReducer';
import trashReducer from './trashReducer';
import solutionReducer  from './solutionReducer';
import notebookReducer  from './notebookReducer';
import sceneReducer from './sceneReducer';
import blotPaperReducer from './blotPaperReducer'
import multipleChoiceQuestionReducer from './multipleChoiceQuestionReducer';
import singleChoiceQuestionReducer from './singleChoiceQuestionReducer';
import undoReducer from './undoReducer';

export default combineReducers({
    modal: modalReducer,
    moveMenu: moveMenuReducer,
    pipette: pipetteReducer,
    solution: solutionReducer,
    blotPaper: blotPaperReducer,
    tipBox: tipBoxReducer,
    trash: trashReducer,
    notebook: notebookReducer,
    scene: sceneReducer,
    MCQ: multipleChoiceQuestionReducer,
    SCQ: singleChoiceQuestionReducer,
    undo: undoReducer
})
